const iBuildingTool: any = {};

/**
 * 函数防抖
 * @param callback 回调函数
 * @param time 时间间隔
 */
iBuildingTool.debounce = function (callback, time: number) {
    let timer: any;
    return function () {
        clearTimeout(timer);
        // eslint-disable-next-line prefer-rest-params
        const args = arguments;
        timer = setTimeout(() => {
            // eslint-disable-next-line prefer-spread
            callback.apply(null, args);
        }, time);
    };
};
const unitStrArr = ['B', 'KB', 'MB', 'GB'];
export function transform(value) {
    let unitIdx = 0;
    // if()
    let sizeCalc = value;
    for (;unitIdx < unitStrArr.length && sizeCalc > 1024; ++unitIdx) {
        sizeCalc /= 1024;
    }
    return sizeCalc.toFixed(2) + unitStrArr[unitIdx];
}

export default iBuildingTool;
